var React = require('react');

function DocumentsBoldInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n            #doc-bold .cls-1 {\n                fill: currentColor;\n            }\n            #doc-bold .cls-2 {\n                fill: none;\n            }\n        ")),React.createElement("path",{"className":"cls-1","d":"M23.24,12.07,19.05,7.85H10.16V26.4H23.24ZM21,24.17H12.39V10.08H18v3.17h3Z","key":1}),React.createElement("polygon",{"className":"cls-1","points":"24.96 13.79 24.96 28.12 13.61 28.12 13.61 29.85 26.69 29.85 26.69 15.52 24.96 13.79","key":2}),React.createElement("rect",{"className":"cls-2","width":"35.86","height":"35.86","key":3})]);
}

DocumentsBoldInline.defaultProps = {"id":"doc-bold","data-name":"Layer 1","viewBox":"0 0 35.86 35.86"};

module.exports = DocumentsBoldInline;

DocumentsBoldInline.default = DocumentsBoldInline;
